import { queryClient } from '@capsicum/common';
import { type FeedTypes, type PostActivityType } from '@capsicum/socios-core';
import { type QueryKey } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

import { FEED_TYPES_QUERY_MAP, type InfiniteQueryPostActivityType } from '../models/feed';

export const useRemoveActivityFromFeed = (feedTypes: Array<FeedTypes>) => {
	/** For exact match and  with derived queries with filters. */
	const removeFromQueriesMap: Array<QueryKey> = useMemo(
		() => feedTypes.flatMap(type => [FEED_TYPES_QUERY_MAP[type], [FEED_TYPES_QUERY_MAP[type]]]),
		[feedTypes]
	);

	const removeActivity = useCallback(
		(activityId: string): void => {
			const removeActivityFromQueries = (key: QueryKey) => {
				queryClient.setQueriesData<InfiniteQueryPostActivityType | undefined>(
					{ exact: false, queryKey: key },
					oldData => {
						if (!oldData?.pages) return;

						const updatedData = {
							...oldData,
							pages: oldData.pages.map(page => ({
								...page,
								data: page.data.filter(
									(activity: PostActivityType) => activity.activityId !== activityId
								)
							}))
						};

						return updatedData;
					}
				);
			};

			removeFromQueriesMap.forEach(removeActivityFromQueries);
		},
		[removeFromQueriesMap]
	);

	return { removeActivity };
};
